import DecidimKit from "src/decidim/editor/extensions/decidim_kit";
import "stylesheets/decidim/editor.scss";
window.DecidimKit = DecidimKit;
window.currentEditors = window.currentEditors || [];
